<script>
	import ProductDetailsModal from './ProductDetailsModal.svelte';
	import { createEventDispatcher } from 'svelte';

	export let product = {};
	export let isSelected = false;
	export let formatCurrency = (amount) =>
		amount !== undefined && amount !== null ? amount.toString() : '';
	export let getDiscountPercentage = (price, regularPrice) => 0;

	const dispatch = createEventDispatcher();

	function toggleSelection() {
		dispatch('toggleSelect', product);
	}
	let showDetailsModal = false;
</script>

<div class="product-card product-grid-item {isSelected ? 'is-selected' : ''}">
	<button
		type="button"
		class="select-button {isSelected ? 'is-selected' : ''}"
		on:click|stopPropagation={toggleSelection}
	>
		{#if isSelected}
			<svg
				xmlns="http://www.w3.org/2000/svg"
				class="select-checkmark"
				viewBox="0 0 20 20"
				fill="currentColor"
			>
				<path
					fill-rule="evenodd"
					d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
					clip-rule="evenodd"
				/>
			</svg>
		{/if}
	</button>

	{#if product.amplified}
		<div class="amplified-badge">Amplified</div>
	{/if}

	{#if product.on_sale}
		<div class="sale-badge">
			{getDiscountPercentage(product.price?.eur, product.regular_price?.eur)}% Off
		</div>
	{/if}

	<button type="button" class="card-content-button" on:click={toggleSelection}>
		<div class="product-image-container">
			{#if product.image}
				<img src={product.image || '/placeholder.svg'} alt={product.title} class="product-image" />
			{:else}
				<div class="placeholder-container">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="placeholder-icon"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
						/>
					</svg>
				</div>
			{/if}
		</div>
		<div class="details-section">
			<h3 class="product-title">{product.title}</h3>
			<p class="product-description">
				{product.description_tokens || 'No description available'}
			</p>
			<div class="price-stock-section">
				<div class="price">
					{#if product.on_sale && product.regular_price?.eur}
						<span class="current-price">{formatCurrency(product.price?.eur)}</span>
						<span class="original-price">{formatCurrency(product.regular_price?.eur)}</span>
					{:else}
						<span class="current-price">{formatCurrency(product.price?.eur)}</span>
					{/if}
				</div>
				<span class="stock-info">
					{product.in_stock ? `Stock: ${product.stock}` : 'Out of stock'}
				</span>
			</div>
			{#if product.category_list && product.category_list.length > 0}
				<div class="category-tags">
					{#each product.category_list.slice(0, 2) as category}
						<span class="category-tag">{category.replace('&amp;', '&')}</span>
					{/each}
					{#if product.category_list.length > 2}
						<span class="category-tag">+{product.category_list.length - 2}</span>
					{/if}
				</div>
			{/if}
		</div>
	</button>

	<div class="product-actions">
		<button class="action-link" on:click={() => (showDetailsModal = true)}>Details</button>
		<span class="action-separator">•</span>
		<button class="action-link shopbox-find-similar sb-findsim-v2">Find Similar</button>
	</div>
	<a style="opacity:0;" class="action-link" target="_blank" href={product.url}>View Product</a>
</div>

<ProductDetailsModal bind:open={showDetailsModal} {product}></ProductDetailsModal>

<style>
	.product-card {
		position: relative;
		overflow: hidden;
		border-radius: 0.5rem;
		border: 1px solid var(--grey-200);
		transition: box-shadow 0.15s ease-in-out;
		display: flex;
		flex-direction: column;
	}
	.product-card:hover {
		box-shadow:
			0 4px 6px -1px rgba(0, 0, 0, 0.1),
			0 2px 4px -1px rgba(0, 0, 0, 0.06);
	}
	.product-card.is-selected {
		box-shadow: 0 0 0 2px var(--accent);
		border-color: var(--accent);
	}

	.select-button {
		position: absolute;
		top: 0.5rem;
		right: 0.5rem;
		z-index: 10;
		display: flex;
		height: 1.25rem;
		width: 1.25rem;
		align-items: center;
		justify-content: center;
		border-radius: 9999px;
		border: 1px solid var(--grey-200);
		background-color: var(--white);
		cursor: pointer;
	}
	.select-button.is-selected {
		border-color: var(--accent);
		background-color: var(--accent);
	}

	.select-checkmark {
		height: 0.75rem;
		width: 0.75rem;
		color: var(--white);
	}

	.amplified-badge,
	.sale-badge {
		position: absolute;
		left: 0.5rem;
		z-index: 10;
		border-radius: 9999px;
		padding: 0.125rem 0.5rem;
		font-size: 0.75rem;
		line-height: 1rem;
		color: white;
	}
	.amplified-badge {
		top: 0.5rem;
		background-color: var(--accent);
	}
	.sale-badge {
		top: 32%;
		background-color: var(--error);
	}

	.card-content-button {
		display: block;
		width: 100%;
		cursor: pointer;
		text-align: left;
		background: none;
		border: none;
		padding: 0;
		flex: 1;
	}

	.product-image-container {
		position: relative;
		height: 10rem;
		width: 100%;
	}

	.product-image {
		height: 100%;
		width: 100%;
		object-fit: contain;
		padding: 0.5rem;
	}

	.placeholder-container {
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: center;
		color: var(--grey-200);
	}

	.placeholder-icon {
		height: 3rem;
		width: 3rem;
	}

	.details-section {
		padding: 1rem;
	}

	.product-title {
		margin-bottom: 0.25rem;
		font-weight: 500;
		color: var(--grey-600);
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		min-height: 2.5rem;
	}

	.product-description {
		margin-bottom: 0.5rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
		color: var(--grey-600);
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		min-height: 2.5rem;
	}

	.price-stock-section {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.current-price {
		font-weight: 700;
		color: var(--grey-600);
	}

	.original-price {
		margin-left: 0.25rem;
		font-size: 0.875rem;
		line-height: 1.25rem;
		color: var(--grey-600);
		text-decoration: line-through;
	}

	.stock-info {
		font-size: 0.875rem;
		line-height: 1.25rem;
		color: var(--grey-600);
	}

	.category-tags {
		margin-top: 0.5rem;
		display: flex;
		flex-wrap: wrap;
		gap: 0.25rem;
	}

	.category-tag {
		border-radius: 9999px;
		background-color: var(--grey-200);
		padding: 0.125rem 0.5rem;
		font-size: 0.65rem;
		line-height: 1rem;
		color: var(--grey-600);
		max-width: 90%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	/* New styles for discrete action links */
	.product-actions {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 1rem 0.75rem;
		opacity: 0.7;
		transition: opacity 0.15s ease-in-out;
	}

	.product-card:hover .product-actions {
		opacity: 1;
	}

	.action-link {
		font-size: 0.75rem;
		color: var(--grey-600);
		text-decoration: none;
		background: none;
		border: none;
		padding: 0;
		cursor: pointer;
		transition: color 0.15s ease-in-out;
		background: none !important;
		margin: 0 !important;
	}

	.action-link:hover {
		color: var(--accent);
		text-decoration: underline;
	}

	.action-separator {
		margin: 0 0.5rem;
		font-size: 0.75rem;
		color: var(--grey-600);
	}
</style>
